module.exports = __webpack_public_path__ + "img/Profile_Icon.9aa7a928.png";